import { Button, Menu } from '@mantine/core';
import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

interface GenerateTestDataButtonProps {
  label: string;
  generateFunction: (count: number) => Promise<any[]>;
  queryKey: string[];
}

export const GenerateTestDataButton = ({ label, generateFunction, queryKey }: GenerateTestDataButtonProps) => {
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const handleGenerate = async (count: number) => {
    setLoading(true);
    try {
      await generateFunction(count);
      queryClient.invalidateQueries({ queryKey });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Menu shadow="md" width={200}>
      <Menu.Target>
        <Button 
          variant="outline" 
          size="sm" 
          loading={loading}
        >
          {label}
        </Button>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item onClick={() => handleGenerate(1)}>Generate 1</Menu.Item>
        <Menu.Item onClick={() => handleGenerate(3)}>Generate 3</Menu.Item>
        <Menu.Item onClick={() => handleGenerate(5)}>Generate 5</Menu.Item>
        <Menu.Item onClick={() => handleGenerate(10)}>Generate 10</Menu.Item>
        <Menu.Item onClick={() => handleGenerate(20)}>Generate 20</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};